import { render, staticRenderFns } from "./LoginSuccess.vue?vue&type=template&id=733e0ca5"
import script from "./LoginSuccess.vue?vue&type=script&lang=js"
export * from "./LoginSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports